module.exports = __webpack_public_path__ + "assets/class-white.362aabce.svg";